import Structure from "@/views/MGT/Organizational/Structure";
export default {
  components: {
    Structure
  },
  name: "OrgDetail",
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};